import { ConversationMember } from "./ConversationMember";

export function mapToSmallConversationMembers(cm: ConversationMember): SmallConversationMember {
  return {
    userExternalId: cm.user.externalId,
    firstName: cm.user.firstName,
    lastName: cm.user.lastName,
    role: "",
    isOwner: cm.isOwner,
    email: cm.user.email,
    tenantNames: "",
    isAvailable: true,
  };
}

export interface SmallConversationMember {
  userExternalId: string;
  firstName: string;
  lastName: string;
  role: string;
  isOwner: boolean;
  email: string;
  isAvailable: boolean;

  /// tenantNames -> names separated by ', '
  tenantNames: string;

  isInternal?: boolean;
}
